import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'
import useStyles from './useStyles'

function TopesTable ({ appParameters }) {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {appParameters.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.app_parameter_code}
                  item={item}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default TopesTable
